import React, {memo, useCallback, useEffect, useMemo, useRef} from 'react';
import {useSelector} from "react-redux";
import {
    addDeliveriesTimeLineItem,
    updateDeliveriesTimeLineItem,
    deleteDeliveriesTimeLineItem
} from "../../../../store/deliveries/actions";
import {
    ActivityTimelineContextProps
} from "../../../../components/v2/activity-timeline/context/types/ActivityTimelineContextProps";

import {useEventSource} from "../../../../hooks/useEventSource/useEventSource";
import {
    ActivityDataType,
    ActivityItem,
    ActivityItems,
} from "../../../../components/v2/activity-timeline/types/types";
import {
    selectDeliveriesTimelineData,
    selectDeliveriesTimelineError,
    selectDeliveriesTimelineIsLoading
} from "../selectors";
import {ActivityTimelineContext} from 'src/react-app/components/v2/activity-timeline/context/activity-timeline-context';
import {ActivityTimelineSync as ActivityTimeline} from "../../../../components/v2/activity-timeline";
import { useAppDispatch } from '../../../../hooks/useAppDispatch/useAppDispatch'


interface DeliveriesTimeLineProps {
    className?: string
    id: string | number
    hideHeader?: boolean
}

export const DeliveryTimeline: React.FC<DeliveriesTimeLineProps> = memo((props: DeliveriesTimeLineProps) => {
    const { id, className, hideHeader } = props
    const dispatch = useAppDispatch();
    const timelineIsLoading = useSelector(selectDeliveriesTimelineIsLoading);
    const timelineError = useSelector(selectDeliveriesTimelineError);
    const timelineItems = useSelector(selectDeliveriesTimelineData);
    const {sse, subscribe} = useEventSource();

    const timelineItemsRef = useRef(timelineItems);
    
    useEffect(() => {
        timelineItemsRef.current = timelineItems;
    }, [timelineItems]);

    const handleDeliveriesTimelineNewItems = useCallback((newItems: ActivityItems[]) => {
        /* todo из-за манго колхозим проверку на соответствие type и id передаваемых и существующих элементов,
        *   подумать как оптимизировать
        * */
        newItems.forEach((newItem) => {
            const currentTimelineItems = timelineItemsRef.current;
            const scopeIndex = currentTimelineItems.itemsDates?.findIndex((date) => date == newItem.date);
            
            if (scopeIndex === -1 || scopeIndex === undefined) {
                dispatch(addDeliveriesTimeLineItem([newItem]));
                return;
            }
            if (!newItem?.items?.length) {
                return;
            }

            const addItems: ActivityItem[] = [];
            const updItems: DeepPartial<ActivityDataType>[] = [];

            for (let newItemByType of newItem.items) {
                const newItemId = newItemByType.data?.id || newItemByType.id;
                let isExisting = false;
                for (let currentItemByType of currentTimelineItems.items[scopeIndex]?.items) {
                    const currentItemId = currentItemByType.data?.id || currentItemByType.id;
                    if (newItemByType.type === currentItemByType.type && newItemId === currentItemId) {
                        updItems.push(newItemByType);
                        isExisting = true;
                        break;
                    }
                }
                if (!isExisting) {
                    addItems.push(newItemByType);
                }
            }

            if (addItems.length) {
                dispatch(addDeliveriesTimeLineItem([{date: newItem.date, items: addItems}]))
            }

            if (updItems.length) {
                updItems.forEach((item) => {
                    dispatch(updateDeliveriesTimeLineItem({date: newItem.date, data: item}))
                })
            }

        })
    }, [dispatch])

    useEffect(() => {
        if (id !== 'new') {
            subscribe(`/api/get-activity/live/delivery/${id}`, handleDeliveriesTimelineNewItems)
        }
        return () => sse?.current?.close();
    }, [id, subscribe, handleDeliveriesTimelineNewItems])


    const updateDeliveriesTimeline = useCallback((activityItem) => {
        dispatch(updateDeliveriesTimeLineItem(activityItem))
    }, [])

    const deleteDeliveriesTimelineItem = useCallback((activityItem) => {
        dispatch(deleteDeliveriesTimeLineItem(activityItem))
    }, [])


    const defaultProps = useMemo(
        (): ActivityTimelineContextProps => ({
            card_id: id,
            card_type: "delivery",
            updateTimeline: updateDeliveriesTimeline,
            deleteTimelineItem: deleteDeliveriesTimelineItem

        }),
        [id],
    );

    return (
        <ActivityTimelineContext.Provider value={defaultProps}>
            <ActivityTimeline
                isLoading={timelineIsLoading}
                items={timelineItems?.items}
                error={timelineError}
                className={className}
                hideHeader={hideHeader}
            />
        </ActivityTimelineContext.Provider>
    )
})

